import { CodeReferenceBlockHighlightRecord } from "models/view-models/code-reference-block-highlights/code-reference-block-highlight-record";
import { HighlightColor } from "utilities/enumerations/highlight-color";
import ServiceHookFactory from "utilities/services/service-hook-factory";

export interface CodeReferenceBlockHighlightCreateParams {
    configurationId: number;
    startingSectionId: number;
    endingSectionId: number;
    startingSectionOffset: number;
    endingSectionOffset: number;
    highlightColor?: HighlightColor;
    note?: string;
}
export interface CodeReferenceBlockHighlightUpdateParams {
    note?: string;
    highlightColor?: HighlightColor;
}

export interface CodeReferenceBlockHighlightResourceParams {
    id: number;
}

const resourceType = CodeReferenceBlockHighlightRecord;
const baseEndpoint = "code-reference-block-highlights";
const resourceEndpoint = `${baseEndpoint}/:id`;

const CodeReferenceBlockHighlightService = {
    useCreate: ServiceHookFactory.useCreateFromPostParams<
        CodeReferenceBlockHighlightRecord,
        CodeReferenceBlockHighlightCreateParams
    >(resourceType, baseEndpoint),

    useDelete:
        ServiceHookFactory.useDelete<CodeReferenceBlockHighlightResourceParams>(
            resourceEndpoint
        ),
    useUpdate: ServiceHookFactory.useUpdateFromPutParams<
        CodeReferenceBlockHighlightRecord,
        CodeReferenceBlockHighlightUpdateParams,
        CodeReferenceBlockHighlightResourceParams
    >(resourceType, resourceEndpoint),
};

export default CodeReferenceBlockHighlightService;
